export const GET_ACCORDION_BLOCK_BY_ID_M = (id, preview: boolean) => `
query {
    accordionBlock(id: "${id}", preview: ${preview}) {
        sys {
          id
        }
        heading
        expanded
        text {
            json
            links {
                entries {
                    hyperlink {
                        ... on Page {
                            sys {id}
                            slug
                            content {
                                __typename
                            }
                        }
                        ... on FileBlock {
                            sys {id}
                            imageVaultFile
                            metaData
                            __typename
                        }
                    }

                    block {
                        __typename
                        ... on ImageBlock {
                        sys {id}
                        ivImage
                        enableZoom
                        imageDescription
                        link {
                            globalLinkItem
                            reference {
                            ...on Page {
                                content {
                                    __typename
                                }
                                slug
                                }
                                ...on FileBlock
                                {
                                imageVaultFile
                                }
                            }
                            url
                            newTab
                        }
                        }
                        ... on TableBlock {
                        sys {id}
                        heading
                        table
                        }
                    }
                }
            }
        }
        audienceCollection{
            items{
                __typename
                sys{id}
                audianceId
            }
        }
        contentAreaCollection {
            items{
                __typename
                ...on AccordionBlock{sys{id}}
                ...on ContactBlock{sys{id}}
                ...on FaqListBlock {sys {id}}
                ...on FileBlock {sys {id}}
                ...on FileListBlock {sys{id}}
                ...on FormBlock {sys{id}}
                ...on ImageBlock {sys {id}}
                ...on InformationBlock {sys {id}}
                ...on Link {sys {id}}
                ...on RestrictedRichTextBlock{sys{id}}
                ...on RichTextBlock {sys{id}}
                ...on TableBlock {sys {id}}
                ...on TeaserBlock {sys{id}}
                ...on TimelineBlock {sys {id}}
                ...on Page {sys {id}}
                ...on PersonalizationBlock {sys {id}}
                ...on Videoblock {sys {id}}
                ... on ColorPaletteBlock {sys {id}}
                ... on PaymentDaysBlock {sys {id}}
            }
        }
    }
}
`;
